// src/components/SidebarItem.js
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./SidebarItem.module.css";
import Icon from "../common/Icon";

export default function SidebarItem({ label, icon, path, collapsed, end = false, badge = 0 }) {
  const showBadge = badge > 0;

  return (
    <NavLink
      to={`/dashboard/${path}`}
      end={end}
      className={({ isActive }) =>
        `${styles.item} ${isActive ? styles.active : ""}`
      }
    >
      <span className={styles.iconWrap}>
        <Icon name={icon} className={styles.icon} />
        {showBadge && collapsed && (
          <span className={`${styles.badge} ${styles.badgeDot}`}>{badge > 99 ? "99+" : badge}</span>
        )}
      </span>
      {!collapsed && <span className={styles.label}>{label}</span>}
      {showBadge && !collapsed && <span className={styles.badge}>{badge > 99 ? "99+" : badge}</span>}
    </NavLink>
  );
}
